export const EVENT_YEAR         = process.env.REACT_APP_EVENT_YEAR         || '2026';
export const EVENT_EDITION      = process.env.REACT_APP_EVENT_EDITION      || '41';
export const EVENT_PARTICIPANTS = process.env.REACT_APP_EVENT_PARTICIPANTS  || '9765';
export const EVENT_LECTURERS    = process.env.REACT_APP_EVENT_LECTURERS     || '129';
export const PRICE_TENT          = process.env.REACT_APP_PRICE_TENT          || '330';
export const PRICE_ACCOMMODATION = process.env.REACT_APP_PRICE_ACCOMMODATION || '390';
export const CONTACT_EMAIL       = process.env.REACT_APP_CONTACT_EMAIL       || 'info@letavy.sk';
